import React from "react";

function Loader() {
  return <span className="loader"></span>;
}

export default Loader;
